define(["require", "jquery", "underscore", "knockout", "@modules/insensitiveProperty"], function (require, $, _, ko, getPropertyCaseInsensitive) {
    var random = function () {
        return ((Math.floor(Math.random() * 99999999) + 1).toString() + "00000000").substring(0, 8);
    };

    return function (params, componentInfo) {
        var self = this;
        var $container = null;

        if (params == null || params.config == null) {
            throw "parameters are missing";
        }

        if (!params.config.optionNameField) {
            throw "optionsNameField param missing";
        }

        if (!params.config.optionValueField) {
            throw "optionsValueField param missing";
        }

        if (!params.config.optionsAvailable) {
            throw "optionsAvailable param missing";
        }

        if (!params.config.optionsSelected) {
            throw "optionsSelected param missing";
        }

        if (!ko.isObservable(params.config.optionsAvailable)) {
            throw "optionsAvailable param is not observable";
        }

        if (!ko.isObservable(params.config.optionsSelected)) {
            throw "optionsSelected param is not observable";
        }

        if (!ko.isObservable(params.config.enabled)) {
            throw "enabled param is not observable";
        }

        $container = $(componentInfo.element).children("div.filter-dropdown-container");

        self.defaultLabel = params.config.buttonText || "Options";
        self.inputPlaceholderText = params.config.inputPlaceholderText || "Search Options";
        self.filterInputId = params.config.filterInputId || "multi-select-input-" + random();
        self.optionNameField = params.config.optionNameField || "name";
        self.optionValueField = params.config.optionValueField || "value";
        self.showDescriptionsEnabled = params.config.showDescriptionsEnabled || false;
        self.descriptions = params.config.optionDescriptions;
        self.showSearchEnabled = params.config.showSearchEnabled || false;
        self.showDescriptions = ko.observable(false);

        self.active = ko.observable(false);
        self.enabled = params.config.enabled;
        self.filterTerm = ko.observable(null).extend({ rateLimit: 400 });
        self.optionsDisplayed = ko.observableArray([]);

        self.loadingFacets = params.config.loadingFacets;
        self.optionsAvailable = params.config.optionsAvailable;
        self.optionsSelected = params.config.optionsSelected;

        self.buttonText = ko.computed(function () {
            var selections = self.optionsSelected();

            if (selections.length === 0) {
                return self.defaultLabel;
            } else if (selections.length === 1) {
                return selections[0];
            } else {
                return selections.length + " items selected";
            }
        });

        self.renderDescription = function (option) {
            var description = getPropertyCaseInsensitive(self.descriptions, option.name);
            return description;
        };

        var toggleOption = function (params, event) {
            $(event.target).parent().toggleClass("checked");

            var $checked = $container.find("div.filter-results-container label.checked");

            var newSelections = _.map($checked, function (item) {
                return $(item).children("input").attr("data-value");
            });

            self.optionsSelected(newSelections);
        };

        self.optionsDisplayed = ko.computed(function () {
            var opts = self.optionsAvailable();

            var filter = self.filterTerm() ? self.filterTerm().toUpperCase() : false;

            var isFiltering = filter && filter.length >= 3;

            if (isFiltering) {
                opts = _.filter(opts, function (item) {
                    return item.value.toUpperCase().indexOf(filter) > -1;
                });
            }

            return _.map(opts, function (item) {
                var regex = filter ? new RegExp(filter, "i") : null;

                return {
                    name: item[self.optionNameField],
                    value: item[self.optionValueField],
                    checked: ko.computed(function () {
                        var opts = self.optionsSelected();
                        return opts && opts.indexOf(item[self.optionValueField]) >= 0 ? "checked" : "";
                    }),
                    click: toggleOption,
                    display: isFiltering ? item.text.replace(regex, "<span>" + filter + "</span>") : item.text,
                    renderDescription: self.renderDescription,
                    showDescriptions: self.showDescriptions
                };
            });
        });

        $(document).bind("mouseup keyup", function (event) {
            if (self.active() && !$container.is(event.target) && $container.has(event.target).length === 0) {
                self.active(false);
            }
        });

        self.click_dropdown = function (params, event) {
            var $target = $(event.target);

            if (!$target.hasClass("disabled") && !$target.parents("a:first").hasClass("disabled")) {
                self.active(!self.active());
            }
        };
    };
});
